/* eslint-disable no-undef */

export const zendesk = {
  close: () => {
    if (process.browser && document.getElementsByClassName('zEWidget-launcher--active').length) {
      zE(() => {
        zE.hide();
      });
    }
  },
  open: (user) => {
    if (process.browser && !document.getElementsByClassName('zEWidget-launcher--active').length) {
      zE(() => {
        if (user) {
          const params = {
            name: user.fullname || ''
          };

          if (user.email) params.email = user.email;
          if (user.phone) params.phone = user.phone;

          zE.identify(params);
        }
        zE.show();
      });
    }
  }
};
